module.exports = __webpack_public_path__ + "static/media/BDO_2026_Logo.08ad10b4.png";